import React, { useEffect, useState } from "react";
import LeaveProcessService from "../services/LeaveProcessService";

const LeaveMaster = () => {

    const [leaveList, setLeaveList] = useState([]);

    const emptyForm = {
        LeaveTypeID: null,
        LeaveCode: "",
        LeaveName: "",
        IsPaid: true,
        IsSystem: false,
        AllowHalfDay: false,
        AllowShortLeave: false,
        AllowAttachment: false,
        GenderApplicable: "Both",
        IsActive: true
    };

    const [form, setForm] = useState(emptyForm);

    useEffect(() => {
        loadLeaves();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm({
            ...form,
            [name]: type === "checkbox" ? checked : value
        });
    };

    const createFormData = (mode) => {
        const fd = new FormData();

        fd.append("Mode", mode);
        fd.append("LeaveTypeID", form.LeaveTypeID || "");
        fd.append("LeaveCode", form.LeaveCode);
        fd.append("LeaveName", form.LeaveName);
        fd.append("IsPaid", form.IsPaid);
        fd.append("IsSystem", form.IsSystem);
        fd.append("AllowHalfDay", form.AllowHalfDay);
        fd.append("AllowShortLeave", form.AllowShortLeave);
        fd.append("AllowAttachment", form.AllowAttachment);
        fd.append("GenderApplicable", form.GenderApplicable);
        fd.append("IsActive", form.IsActive);

        return fd;
    };

    const loadLeaves = async () => {
        const fd = new FormData();
        debugger;
        fd.append("Mode", "S");

        const res = await LeaveProcessService.setLeaveMaster(fd);
        setLeaveList(res?.data?.result || []);
    };

    const handleSubmit = async () => {

        if (!form.LeaveCode || !form.LeaveName) {
            alert("Please fill Leave Code and Leave Name");
            return;
        }

        const mode = form.LeaveTypeID ? "U" : "I";

        const fd = createFormData(mode);

        await LeaveProcessService.setLeaveMaster(fd);

        alert("Saved Successfully");

        loadLeaves();
        setForm(emptyForm);
    };

    const handleEdit = (item) => {
        setForm({
            LeaveTypeID: item.leaveTypeID,
            LeaveCode: item.leaveCode,
            LeaveName: item.leaveName,
            IsPaid: item.isPaid,
            IsSystem: item.isSystem,
            AllowHalfDay: item.allowHalfDay,
            AllowShortLeave: item.allowShortLeave,
            AllowAttachment: item.allowAttachment,
            GenderApplicable: item.genderApplicable,
            IsActive: item.IsActive
        });
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Delete this leave type?")) return;

        const fd = new FormData();
        fd.append("Mode", "D");
        fd.append("LeaveTypeID", id);

        await LeaveProcessService.setLeaveMaster(fd);

        loadLeaves();
    };

    return (

        <div className="container mt-4">

            <h3 className="mb-3">Leave Master</h3>

            <div className="card p-4 mb-4">

                {/* Row 1 */}
                <div className="row g-3">

                    <div className="col-md-3">
                        <label>Leave Code</label>
                        <input name="LeaveCode" value={form.LeaveCode}
                            onChange={handleChange} className="form-control" />
                    </div>

                    <div className="col-md-3">
                        <label>Leave Name</label>
                        <input name="LeaveName" value={form.LeaveName}
                            onChange={handleChange} className="form-control" />
                    </div>

                    <div className="col-md-2">
                        <label>Applicable For</label>
                        <select name="GenderApplicable"
                            value={form.GenderApplicable}
                            onChange={handleChange}
                            className="form-control">
                            <option value="Both">Both</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                        </select>
                    </div>

                    <div className="col-md-2">
                        <label>Status</label>
                        <select name="IsActive"
                            value={form.IsActive}
                            onChange={(e) =>
                                setForm({ ...form, IsActive: e.target.value === "true" })
                            }
                            className="form-control">
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                        </select>
                    </div>

                </div>

                {/* Row 2 - Checkboxes */}
                <div className="row mt-3">

                    <div className="col-md-2">
                        <input type="checkbox" name="IsPaid"
                            checked={form.IsPaid}
                            onChange={handleChange} /> Paid
                    </div>

                    <div className="col-md-2">
                        <input type="checkbox" name="IsSystem"
                            checked={form.IsSystem}
                            onChange={handleChange} /> System
                    </div>

                    <div className="col-md-2">
                        <input type="checkbox" name="AllowHalfDay"
                            checked={form.AllowHalfDay}
                            onChange={handleChange} /> Half Day
                    </div>

                    <div className="col-md-2">
                        <input type="checkbox" name="AllowShortLeave"
                            checked={form.AllowShortLeave}
                            onChange={handleChange} /> Short Leave
                    </div>

                    <div className="col-md-2">
                        <input type="checkbox" name="AllowAttachment"
                            checked={form.AllowAttachment}
                            onChange={handleChange} /> Attachment
                    </div>

                </div>

                {/* Buttons */}
                <div className="mt-3">
                    <button className="btn btn-success me-2" onClick={handleSubmit}>
                        {form.LeaveTypeID ? "Update" : "Save"}
                    </button>

                    <button className="btn btn-secondary"
                        onClick={() => setForm(emptyForm)}>
                        Reset
                    </button>
                </div>

            </div>

            {/* Table */}
            <table className="table table-bordered table-striped">

                <thead className="table-dark">
                    <tr>
                        <th>ID</th>
                        <th>Code</th>
                        <th>Name</th>
                        <th>Gender</th>
                        <th>Paid</th>
                        <th>System</th>
                        <th>Half Day</th>
                        <th>Short Leave</th>
                        <th>Attachment</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody>

                    {leaveList.map((item) => (

                        <tr key={item.leaveTypeID}>
                            <td>{item.leaveTypeID}</td>
                            <td>{item.leaveCode}</td>
                            <td>{item.leaveName}</td>
                            <td>{item.genderApplicable}</td>
                            <td>{item.isPaid ? "Yes" : "No"}</td>
                            <td>{item.isSystem ? "Yes" : "No"}</td>
                            <td>{item.allowHalfDay ? "Yes" : "No"}</td>
                            <td>{item.allowShortLeave ? "Yes" : "No"}</td>
                            <td>{item.allowAttachment ? "Yes" : "No"}</td>
                            <td>{item.isActive ? "Active" : "Inactive"}</td>

                            <td>
                                <button className="btn btn-warning btn-sm me-2"
                                    onClick={() => handleEdit(item)}>
                                    Edit
                                </button>

                                {/* <button className="btn btn-danger btn-sm"
                                    onClick={() => handleDelete(item.leaveTypeID)}>
                                    Delete
                                </button> */}
                            </td>
                        </tr>

                    ))}

                </tbody>

            </table>

        </div>
    );
};

export default LeaveMaster;